import { render, staticRenderFns } from "./ViewMaterial.vue?vue&type=template&id=957280ea&scoped=true"
import script from "./ViewMaterial.vue?vue&type=script&lang=js"
export * from "./ViewMaterial.vue?vue&type=script&lang=js"
import style0 from "./ViewMaterial.vue?vue&type=style&index=0&id=957280ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957280ea",
  null
  
)

export default component.exports